<template>
<!-- 渠道管理列表页-旧版本 -->
  <div>
    <div class="commonFilter">
      <div class="card-container">
        <div class="card-content">
          <Form ref="pageParams" :model="pageParams" :label-width="90" label-position="right">
            <div class="platformSearch">
              <!-- 状态 -->
                <Form-item :label="$t('common.status') + '：'">
                  <keep-alive>
                    <Button-group>
                      <template v-for="(item, index) in isValidList">
                        <Button v-if="item.selected" type="primary" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                        <Button v-if="!item.selected" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                      </template>
                    </Button-group>
                  </keep-alive>
                </Form-item>
              <!-- 类型 -->
                <Form-item :label="$t('logisticsProvider.channelType') + '：'">
                  <keep-alive>
                    <Button-group>
                      <template v-for="(item, index) in channelTypeList">
                        <Button v-if="item.selected" type="primary" @click="getchannelType(index, item.id)" :key="index">{{item.title}}</Button>
                        <Button v-if="!item.selected" @click="getchannelType(index, item.id)" :key="index">{{item.title}}</Button>
                      </template>
                    </Button-group>
                  </keep-alive>
                </Form-item>
                <Row>
                  <Col span="5">
                    <Form-item :label="$t('logisticsProvider.channelName') + '：'">
                      <Input v-model.trim="pageParams.shippingMethodName"></Input>
                    </Form-item>
                  </Col>
                  <Col span='3' style="margin-left:62px;">
                    <Button type="primary" v-once icon="search" @click="search">{{$t('common.search')}}</Button>
                  </Col>
                </Row>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <!--操作区-->
    <div class="addCanal">
      <Button type="primary" @click="addBtn" icon="plus">{{ $t('logisticsProvider.addCanal') }}</Button>
    </div>
    <!-- 列表 -->
    <div class="orderTable normalTop">
      <Table highlight-row border :columns="canalColumns" :height="tableHeight" :data="canalData"></Table>
      <div class="table-page">
        <div class="table-page-right">
          <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
        </div>
      </div>
    </div>
    <!-- 新增和编辑渠道 -->
    <channelManagementDetailOld ref="canalDetail" :canalDetailModal="canalDetailModal" :shippingId="shippingId" :addFlag="addFlag"></channelManagementDetailOld>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import channelManagementDetailOld from './channelManagementDetail_old';
export default {
  mixins: [ Mixin, tableMixin ],
  components: {
    channelManagementDetailOld
  },
  data () {
    let self = this;
    return {
      addFlag: '', // 新增标识
      shippingId: null,
      pageParamsStatus: false, // 每次更新完pageParms都要设置成true触发刷新
      pageParams: {
        isValid: null, // 启用状态（选全部传空，1：是，0：否）
        logisType: null, // 物流类型（选全部传空，1平邮,2挂号,3专线,4商业快递,5FBA头程）
        pageNum: 1,
        pageSize: 10,
        shippingMethodName: null // 渠道名称
      },
      isValidList: [ // 状态
        {
          title: self.t('common.all'),
          id: null,
          selected: true
        },
        {
          title: self.t('common.status1'),
          id: 1,
          selected: false
        },
        {
          title: self.t('common.status0'),
          id: 0,
          selected: false
        }
      ],
      channelTypeList: [ // 类型
        {
          title: self.t('common.all'),
          id: null,
          selected: true
        },
        {
          title: self.t('common.logisType1'),
          id: 1,
          selected: false
        },
        {
          title: self.t('common.logisType2'),
          id: 2,
          selected: false
        },
        {
          title: self.t('common.logisType3'),
          id: 3,
          selected: false
        },
        {
          title: self.t('common.logisType4'),
          id: 4,
          selected: false
        },
        {
          title: self.t('common.logisType5'),
          id: 5,
          selected: false
        }
      ],
      canalColumns: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelNum'),
          key: 'shippingMethodCode',
          align: 'center'
        },
        {
          title: self.t('common.status'),
          key: 'isValid',
          align: 'center',
          render (h, params) {
            return params.row.isValid === 1
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.status1'))
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.status0'));
          }
        },
        {
          title: self.t('common.channelTypes'),
          key: 'logisType',
          align: 'center',
          render: (h, params) => {
            if (params.row.logisType === 1) {
              return h('span', self.t('common.logisType1'));
            } else if (params.row.logisType === 2) {
              return h('span', self.t('common.logisType2'));
            } else if (params.row.logisType === 3) {
              return h('span', self.t('common.logisType3'));
            } else if (params.row.logisType === 4) {
              return h('span', self.t('common.logisType4'));
            } else if (params.row.logisType === 5) {
              return h('span', self.t('common.logisType5'));
            }
          }
        },
        {
          title: self.t('logisticsProvider.expectTime'),
          key: 'expectedTime',
          align: 'center'
        },
        {
          title: self.t('common.operation'),
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.canalDetailModal = true;
                    self.shippingId = params.row.shippingMethodId; // 渠道ID
                    self.addFlag = 'edit';
                  }
                }
              }, self.t('common.edit')),
              params.row.isValid
                ? h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.shippingMethodId, params.row.isValid);
                    }
                  }
                }, self.t('common.status0'))
                : h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.shippingMethodId, params.row.isValid);
                    }
                  }
                }, self.t('common.status1'))
            ]);
          }
        }
      ],
      canalData: [],
      total: 0, // 总记录数
      canalDetailModal: false // 是否显示选择映射sku模态窗
    };
  },
  methods: {
    getIsValidStatus (index, id) { // 状态筛选
      let v = this;
      v.pageParams.isValid = id;
      v.isValidList.forEach((n, i) => {
        if (i === index) {
          n.selected = true;
        } else {
          n.selected = false;
        }
      });
    },
    getchannelType (index, id) { // 类型筛选
      let v = this;
      v.pageParams.logisType = id;
      v.channelTypeList.forEach((n, i) => {
        if (i === index) {
          n.selected = true;
        } else {
          n.selected = false;
        }
      });
    },
    search () { // 查询
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    // 新增渠道
    addBtn () {
      let v = this;
      v.$nextTick(function () {
        v.shippingId = null;
        v.canalDetailModal = true;
        v.addFlag = 'add';
      });
    },
    // 获取渠道列表数据
    getList () {
      let v = this;
      if (v.pageParams.shippingMethodName === '') {
        v.pageParams.shippingMethodName = null;
      }
      v.axios.post(api.get_shipListPage, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.canalData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 修改渠道状态
    changeStatus (shippingMethodId, isValid) {
      let v = this;
      if (isValid) {
        isValid = 0;
      } else {
        isValid = 1;
      }
      v.axios.post(api.edit_shipStatus + '?shippingMethodId=' + shippingMethodId + '&isValid=' + isValid)
        .then(res => {
          if (res.data.code === 0) {
            v.pageParamsStatus = true;
            if (isValid === 1) {
              v.$Message.success(v.t('common.enableOk'));
            } else if (isValid === 0) {
              v.$Message.success(v.t('common.disableOk'));
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    this.getList();
    this.tableHeight = this.getTableHeight(452);
  },
  watch: {
    pageParamsStatus (n) {
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/channelManagement_old.vue